import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Login from '../views/auth/Login.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Login',
    component: Login,
  },
  {
    path: '/',
    name: 'Website',
    component: () => import('../views/Website.vue'),
    children: [
      {
        path: 'cars',
        name: 'Cars',
        component: () => import('../views/Cars.vue'),
      },
      {
        path: 'cars/new',
        name: 'NewCar',
        component: () => import('../views/Car.vue'),
      },
      {
        path: 'cars/:id',
        name: 'Car',
        component: () => import('../views/Car.vue'),
      },
      {
        path: 'parts',
        name: 'Parts',
        component: () => import('../views/Parts.vue'),
      },
      {
        path: 'parts/new',
        name: 'NewPart',
        component: () => import('../views/Part.vue'),
      },
      {
        path: 'parts/:id',
        name: 'Part',
        component: () => import('../views/Part.vue'),
      },
      {
        path: 'options',
        name: 'Options',
        component: () => import('../views/Options.vue'),
      },
      {
        path: 'mails',
        name: 'Mails',
        component: () => import('../views/Mails.vue'),
      },
      {
        path: 'sells',
        name: 'Sells',
        component: () => import('../views/Sells.vue'),
      },
    ],
  },
];

const router = new VueRouter({
  scrollBehavior(to, from, savedPosition) {
    if ('scrollRestoration' in history) { // eslint-disable-line
      history.scrollRestoration = 'manual'; // eslint-disable-line
    }
    let position = { x: 0, y: 0 };
    if (savedPosition) {
      position = savedPosition;
    }
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(position);
      }, 200);
    });
  },
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
